import { apiPost } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";

export function registerUser(obj) {
    return async (dispatch) => {
        dispatch({ type: 'REGISTER_REQUEST' });

        try {
            const response = await apiPost(apiEndpoints.register.register(), obj);

            if (response?.status === 200) {
                dispatch({
                    type: 'REGISTER_SUCCESS',
                    payload: response.data,
                });
                return response.data; 
            } else {
                dispatch({
                    type: 'REGISTER_SUCCESS',
                    payload: response.detail || "Registration failed",
                });
                return response.detail; 
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred during registration";
            dispatch({
                type: 'REGISTER_FAILURE',
                payload: errorMessage,
            });
            throw new Error(errorMessage);
        }
    };
}

export function resetRegisterResponse() {
    return (dispatch) =>{
        dispatch({
            type: "RESET_REGISTER_RESPONSE"
        })
    }
}

export function resend (obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.register.resend(), obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'RESEND_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RESEND_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
  }


  export const confirmAccount = (obj) => async (dispatch) => {
    dispatch({ type: "CONFIRMATION_REQUEST" });

    try {
        const response = await apiPost(apiEndpoints.register.confirmation(), obj);

        if (response?.data?.detail?.status === "success") {
            dispatch({
                type: "CONFIRMATION_SUCCESS",
                payload: response.data,
            });
        } else {
            dispatch({
                type: "CONFIRMATION_FAILURE",
                payload: response.data?.detail?.message || "Confirmation failed",
            });
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || "An error occurred during confirmation";
        dispatch({
            type: "CONFIRMATION_FAILURE",
            payload: errorMessage,
        });
    }
};

